/* tslint:disable */
/* eslint-disable */
/**
 * Viterbit API
 * This is the documentation for viterbit\'s apps
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateLeaveReasonCommand
 */
export interface CreateLeaveReasonCommand {
    /**
     * 
     * @type {string}
     * @memberof CreateLeaveReasonCommand
     */
    leavePolicyId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateLeaveReasonCommand
     */
    name?: string;
}

/**
 * Check if a given object implements the CreateLeaveReasonCommand interface.
 */
export function instanceOfCreateLeaveReasonCommand(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "leavePolicyId" in value;

    return isInstance;
}

export function CreateLeaveReasonCommandFromJSON(json: any): CreateLeaveReasonCommand {
    return CreateLeaveReasonCommandFromJSONTyped(json, false);
}

export function CreateLeaveReasonCommandFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateLeaveReasonCommand {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'leavePolicyId': json['leavePolicyId'],
        'name': !exists(json, 'name') ? undefined : json['name'],
    };
}

export function CreateLeaveReasonCommandToJSON(value?: CreateLeaveReasonCommand | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'leavePolicyId': value.leavePolicyId,
        'name': value.name,
    };
}

